export default __webpack_public_path__ + "locales/hy-AM/JavascriptSdk.json?hash=0ec3b57a77b3c2f1b022ce6a5547dc22";